import React, { ReactNode, useContext, useState, useEffect } from 'react';
import { TabsContext } from './TabsContext';

type TabPanelProps = {
  children: ReactNode;
  value: string;
};

export default function TabPanel({ children, value }: TabPanelProps) {
  const context = useContext(TabsContext);
  const [isTransitioningIn, setIsTransitioningIn] = useState(false);

  if (!context) {
    throw new Error('TabPanel must be used within a Tabs component');
  }

  const { activeTab } = context;
  const isActive = activeTab === value;

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;

    if (isActive) {
      // Set a timeout to allow the component to mount with opacity-0
      // before transitioning to opacity-100.
      timer = setTimeout(() => {
        setIsTransitioningIn(true);
      }, 10); // A small delay is sufficient
    } else {
      setIsTransitioningIn(false); // Reset when the panel is no longer active
    }

    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [isActive]);

  // Don't render if not the active tab
  if (!isActive) {
    return null;
  }

  return (
    <div
      className={`transition-opacity duration-600 ease-out ${
        isTransitioningIn ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {children}
    </div>
  );
}
